<div class="container">
  <img class="wguLogo" src="assets/images/wgu-logo-blue.svg" alt="WGO logo">
  <span class="username" (click)="logout()" onkeydown="logout()">
    <mat-icon class="linkIcon" >logout</mat-icon>
    LOG OUT
  </span>
</div>
<div class="legal">
  © {{year}} Western Governors University - WGU. All Rights Reserved.
</div>
